import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-template-m c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-template-m__inner" }
const _hoisted_5 = { class: "p-the-template-m__card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheSimpleHeader = _resolveComponent("TheSimpleHeader")!
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_TheFormStep = _resolveComponent("TheFormStep")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_TheSimpleHeader, null, null, 512), [
        [_vShow, _ctx.isSimpleHeader]
      ]),
      _withDirectives(_createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512), [
        [_vShow, !_ctx.isSimpleHeader]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CommonHeading, { class: "p-the-template-m__heading" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "heading", {}, undefined, true)
            ]),
            _: 3
          }),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.step)
              ? (_openBlock(), _createBlock(_component_TheFormStep, {
                  key: 0,
                  step: _ctx.step,
                  options: _ctx.stepOptions
                }, null, 8, ["step", "options"]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "body", {}, undefined, true)
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}